<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import dayjs from '@/lib/dayjs'

const hrs = ref<string | null>(null)
const mins = ref<string | null>(null)
const hideColon = ref(false)

let clockUpdIntval: ReturnType<typeof setInterval> | null = null
let colonUpdIntval: ReturnType<typeof setInterval> | null = null

function updateClock() {
  const mskDate = dayjs(new Date()).tz('Europe/Moscow').startOf('minute')
  hrs.value = mskDate.format('HH')
  mins.value = mskDate.format('mm')
}

function toggleColon() {
  hideColon.value = !hideColon.value
}

onMounted(() => {
  updateClock()

  const beforeNextMin = 60000 - (Date.now() % 60000)
  setTimeout(() => {
    updateClock()
    clockUpdIntval = setInterval(updateClock, 60000)
  }, beforeNextMin)

  const beforeNextSec = 1000 - (Date.now() % 1000)
  setTimeout(() => {
    toggleColon()
    colonUpdIntval = setInterval(toggleColon, 1000)
  }, beforeNextSec)
})

onBeforeUnmount(() => {
  if (clockUpdIntval) clearInterval(clockUpdIntval)
  if (colonUpdIntval) clearInterval(colonUpdIntval)
})
</script>

<template>
  <span class="webinar-clock">
    <span>{{ hrs }}</span>
    <span class="webinar-clock__colon" :class="{ 'webinar-clock__colon_hidden': hideColon }">:</span>
    <span>{{ mins }}</span>
    &nbsp;МСК
  </span>
</template>

<style lang="scss">
.webinar-clock {
  @include text-body-bold;
  // So the line breaks won't be rendered as spaces
  display: flex;

  &__colon_hidden {
    opacity: 0;
  }
}
</style>
